import { Button, Group, Text } from '@mantine/core';

/**
 * "Showing N of 312" and *Load more* — the grids' footer, the same on the grid and the cards.
 * Without a `total` (a list whose size is not known up front) it reads "Showing N".
 * Omitted: no count, only *Load more* — the audit log's foot.
 */
export const LoadMoreFooter = ({
    shown,
    total,
    filtered,
    hasMore,
    isLoadingMore,
    onLoadMore,
}: {
    shown?: number;
    total?: number | null;
    /** A row filter is active — reads the matched count instead of "of `total`". */
    filtered?: boolean;
    hasMore: boolean;
    isLoadingMore: boolean;
    onLoadMore: () => void;
}) => (
    <Group gap="sm">
        {shown !== undefined && (
            <Text fz="xs" c="dimmed">
                {filtered
                    ? `Showing ${shown} matching`
                    : total == null
                      ? `Showing ${shown}`
                      : `Showing ${shown} of ${total}`}
            </Text>
        )}
        {hasMore && (
            <Button size="compact-xs" variant="subtle" loading={isLoadingMore} onClick={onLoadMore}>
                Load more
            </Button>
        )}
    </Group>
);
